// extracted by mini-css-extract-plugin
export default {"welcomeWrapper":"welcomeNote_welcomeWrapper__uav-k","childWrp":"welcomeNote_childWrp__bQW5J"};